import LoadingOverlay from "../../components/LoadingOverlay";

export default function ReviewResult({ answer, error, loading, onCopy }) {
  return (
    <div className="reviewResult mrt30">
      <div className="answer">
        <h4>AI 답변 결과 :</h4>

        {loading ? (
          <LoadingOverlay visible={loading} />
        ) : error ? (
          <p className="error">{error}</p>
        ) : answer ? (
          <p>{answer}</p>
        ) : (
          <p>리뷰를 붙여넣고 “리뷰 답변 생성하기”를 눌러 주세요.</p>
        )}

        <div>
          <button className="copy" onClick={onCopy} disabled={!answer}>
            답변 복사
          </button>
        </div>
      </div>
    </div>
  );
}
